import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CareerTab from "./CareerTab";
import { AiOutlineFolderOpen, AiOutlineArrowLeft } from "react-icons/ai";
import { fetchJobs, fetchScholarships } from "../../../actions/career.action";
import EmptyList from "../../../components/EmptyList";

export default function CareerHome() {
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    career: { jobs, scholarships },
  } = useSelector(({ careerReducer }) => ({
    career: careerReducer,
  }));

  useEffect(() => {
    dispatch(fetchJobs());
    dispatch(fetchScholarships());
  }, []);

  console.log({ jobs, scholarships });

  return (
    <div className="">
      <div className="doc_processing_color h-40 px-2 pt-3">
        <div className="text-md">
          <AiOutlineArrowLeft
            size={25}
            onClick={() => history.goBack()}
            className="mb-5 cursor-pointer"
          />
          <span className="text-2xl text-green-800 font-serif font-bold">
            Jobs/Scholarships
          </span>
        </div>
        <div className="text-md">
          Get update from secretariat on job & secretariat
        </div>
      </div>
      <div className="px-2 pt-6">
        <span className="text-2xl font-serif font-bold pl-4">Jobs</span>
        {jobs.length === 0 ? (
          <EmptyList text={"No created job yet!"} />
        ) : (
          <div className="px-2 pt-6">
            {jobs.map((job) => {
              return (
                <CareerTab
                  image={job.imageUrl}
                  key={job.id}
                  name={job.title}
                  desc={job.description}
                  link={`careers-details`}
                  data={job}
                  icon={
                    <AiOutlineFolderOpen
                      size={20}
                      color="#D5B354"
                      className="mr-2"
                    />
                  }
                />
              );
            })}
          </div>
        )}
      </div>
      <div className="px-2 pt-6">
        <span className="text-2xl font-serif font-bold pl-4">Scholarships</span>
        {scholarships.length === 0 ? (
          <EmptyList text={"No created scholarship yet!"} />
        ) : (
          <div>
            {scholarships.map((scholarship) => {
              return (
                <CareerTab
                  image={scholarship.imageUrl}
                  key={scholarship.id}
                  name={scholarship.title}
                  desc={scholarship.description}
                  data={scholarship}
                  link={`careers-details`}
                  icon={
                    <AiOutlineFolderOpen
                      size={20}
                      color="#D5B354"
                      className="mr-2"
                    />
                  }
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
